import BaseCrudRequests from "./BaseCrudRequests";

/**
 * ProjectAccessTokens model
 *
 * @param {ApiHelper} api
 */
export default class ProjectAccessTokensRequests extends BaseCrudRequests {
    baseUrl = '/projects/%%projectId%%/access-tokens';

    constructor(api, projectId) {
        super(api);

        if (projectId) {
            this.baseUrl = this.baseUrl.replace('%%projectId%%', projectId);
        }
    }


    async list(filter = {}, sorting =  null, status = null, errorHandler) {
        let url = this.baseUrl;
        let query = {};
        if (filter.searchText) {
            query.filter = filter.searchText;
        }
        if (filter.page) {
            query.page = filter.page;
        }
        if (sorting) {
            query.sort = sorting.field;
            query.direction = sorting.direction;
        }
        if (status) {
            query.status = status;
        }
        if (Object.keys(query).length) {
            url += '?' + new URLSearchParams(query).toString();
        }

        const response = await this.api.getRequest(url);
        return this.processResponse(response, errorHandler);
    }


    async update(pk, data, errorHandler) {
        const url = this.baseUrl+'/' + pk;

        const response = await this.api.putRequest(url, data);

        return this.processResponse(response, errorHandler);
    }
}